import { render, staticRenderFns } from "./ElderlyOrder.vue?vue&type=template&id=16600fe5&scoped=true&"
import script from "./ElderlyOrder.vue?vue&type=script&lang=js&"
export * from "./ElderlyOrder.vue?vue&type=script&lang=js&"
import style0 from "./ElderlyOrder.vue?vue&type=style&index=0&id=16600fe5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16600fe5",
  null
  
)

export default component.exports